import axios from 'axios';
import {Toast} from 'vant';
import qs from 'qs';
import {serverUrl} from '@/api/baseMap'


/**
 * 
 * 正常的接口请求
 * 
 */
// 创建axios实例
const requestSpec = axios.create({
    baseURL: serverUrl,
    timeout: 1000 * 20,
    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
    withCredentials: true
});

// 请求拦截器
requestSpec.interceptors.request.use(
  config => {
    if (config.method == 'post') {
      let obj = JSON.parse(JSON.stringify(config.data));
      obj.c = JSON.stringify({'clientType': 5, 'deviceType': '', 'appVersion': '', 'p': '', 'cityId': ''});
      config.data = qs.stringify(obj)
    }
    return config;
  },
  error => Promise.error(error)
)

// 响应拦截器
requestSpec.interceptors.response.use(
  res => {
    // 请求成功
    if (res.status == 200) {//http表示成功的状态
      return Promise.resolve(res.data)
    } else {
      Toast({
        message: '服务器异常',
        duration: 2000,
      });
    }
  },
  // 请求失败
  error => {
    Toast.clear()
    Toast({
        message: '服务器异常',
        duration: 2000,
    });
  }
)

export{
  requestSpec
}


// WEBPACK FOOTER //
// ./src/assets/js/checkLogin.js